import React, { useState } from "react";
import {
	QuestionCircleOutlined,
	RightOutlined,
	LeftOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
	Space,
	Button,
	Drawer,
	Select,
	Popconfirm,
	Descriptions,
	Table,
	Tag,
	Modal,
	Switch,
	Col, 
	Row,
	Divider,
	Input,
	message,
	DatePicker,
} from "antd";
import {	
	PdfReportReview,
	InvoiceNormalTemplate,
} from "./";
import PropTypes from "prop-types";
import { InvoiceStates, UserRols } from "../../constants";
import { formatShownDate } from "./invoice_templates/utils";
import { frases, generate_invoice_pdf } from "../../services";
import { formatNumberOfCurrency } from "../../utils/Formaters";
import { useInvoiceFields, useInvoiceSend, useInvoiceStateManagement } from "./hooks";
import { noSelectedInvoice } from "./utils";

const { TextArea } = Input;

const placement = "right";

// const decodeText = (text) => {
// 	const decodedText = he.decode(text);
// 	return decodedText;
// };

const getKindOfAccounts = {
	"in": "sale_accounts",
	"out": "expense_accounts",
};

const getKindOfType = {
	"in": "sale_type",
	"out": "expense_type",
};

export const Invoice = ({
	// ESCENTIAL PROPERTIES
	token,
	currentInvoice,
	lastSelectedState,
	user,
	company,
	position = "",
	// Filters Allowed
	AllowedInvoicesStatesForEdit = [],
	UnallowedUserForEdit = [],
	// EMITION FUNCTIONS
	onUpdateItem = () => {},
	onEmitClose = () => {},	
	onChargePrevious = () => {},
	onChargeNext = () => {},
	onSubmitInvoiceChanges = () => {},
	onResetInvoices = () => {},
}) => {
	if(position !== "in" && position !== "out"){
		message.error("Error del Developer: Solo se permite posicion 'in' u 'out'");
		return <></>;
	}

	const { 
		isModalOpenSend, 
		isr, 
		sendWithIsr,
		findAccountNameById,
		openModal,
		closeModal, 
		toggleIsr,
	} = useInvoiceStateManagement({ currentInvoice, company });
	
	const { 
		loadingInvoices,
		queueHandleInvoiceStateChange,
		queueHandleSubmit,
		queueHandleCancel,
		handleOpenInvoice,
	} = useInvoiceSend({
		token,
		company,
		position,		
		onSubmitInvoiceChanges,
		onResetInvoices,
		onChargeNext,
	});

	const {
		// editItemDescription,
		selectItemClassification,
		selectItemAnalyticClassification,
		updateGeneralFields,
		// getDiaryInformation,
	} = useInvoiceFields({
		currentInvoice,
		onUpdateItem,
		company,
		position,
	});

	const handleExcludeInvoice = () => queueHandleInvoiceStateChange("modify_state", currentInvoice, InvoiceStates.EXCLUDED);
	const handleMoveToHistory = () => queueHandleInvoiceStateChange("modify_state", currentInvoice, InvoiceStates.HISTORY);
	const handleIncludeInvoice = () => queueHandleInvoiceStateChange("restore", currentInvoice);
	const handleCancelInvoice = () => queueHandleCancel(currentInvoice);
	const handleSendInvoice = () => queueHandleSubmit(currentInvoice, sendWithIsr);
	
	const handleChangeDiary = (value) => {
		updateGeneralFields("diary", value);
	};

	const handleChangeType = (value) => {
		updateGeneralFields(getKindOfType[position], value);
	};

	const handleDescription = (value) => {
		updateGeneralFields("description", value);
	};

	const handleChangeAccountingDate = (value) => {
		if (value) {
			// Format the date in YYYY-MM-DD format without timezone
			const formattedDate = value.format("YYYY-MM-DD");
			updateGeneralFields("accounting_date", formattedDate);
		} else {
			updateGeneralFields("accounting_date", null);
		}
	};

	const handleOkSend = () => {
		closeModal();		
		handleSendInvoice();
	};
		
	const [openReviewInvoice, setOpenReviewInvoice] = useState(false);				
	
	return (
		<Drawer
			title={currentInvoice.receptor_name}
			placement={placement}
			width="100%"
			onClose={onEmitClose}
			open={JSON.stringify(currentInvoice) !== JSON.stringify(noSelectedInvoice(position))}
			extra={
				<Space>
					{/* // Take in consideration that has the previos states here of blick and bank */}
					{lastSelectedState === InvoiceStates.UNVERIFIED && (
						<>
							{
								user.role === UserRols.ARO_ADMIN &&
								<div>
									ID: {currentInvoice.id}
								</div>
							}
							{
								user.role !== UserRols.CLIENT && user.role !== UserRols.BILLING &&
								<Popconfirm
									title="Pasar Factura a historia"
									description="Estas seguro que quieres pasar a historia esta factura?"
									onConfirm={handleMoveToHistory}
									okButtonProps={{
										loading: loadingInvoices.includes(currentInvoice.id),
									}}
									icon={<QuestionCircleOutlined style={{ color: "#edc01c" }} />}
								>
									<Button
										type="primary"
										size="large"
										style={{
											width: "200px",
										}}
										loading={loadingInvoices.includes(currentInvoice.id)}
									>
										Historia
									</Button>
								</Popconfirm>
							}
							{
								user.role !== UserRols.BILLING &&
								<Popconfirm
									title="Excluír Factura"
									description="Estas seguro que quieres excluír esta factura?"
									onConfirm={handleExcludeInvoice}
									okButtonProps={{
										loading: loadingInvoices.includes(currentInvoice.id),
									}}
									icon={<QuestionCircleOutlined style={{ color: "#edc01c" }} />}
								>
									<Button
										type="primary"
										danger
										size="large"
										style={{
											width: "200px",
										}}
										loading={loadingInvoices.includes(currentInvoice.id)}
									>
										Excluír
									</Button>
								</Popconfirm>
							}
						</>
					)}
					{/* // Take in consideration that has the previos states here of blick and bank */}
					{	(
						lastSelectedState === InvoiceStates.EXCLUDED || 
							lastSelectedState === InvoiceStates.HISTORY || 
							lastSelectedState === InvoiceStates.NOTIFICATION_SENT
					) && 
							user.role !== UserRols.BILLING &&
						<Popconfirm
							title="Incluír Factura"
							description="Estas seguro que quieres incluír esta factura?"
							onConfirm={handleIncludeInvoice}
							okButtonProps={{
								loading: loadingInvoices.includes(currentInvoice.id),
							}}
							icon={<QuestionCircleOutlined style={{ color: "#edc01c" }} />}
						>
							<Button
								type="primary"
								size="large"
								style={{
									width: "200px",
								}}
								loading={loadingInvoices.includes(currentInvoice.id)}
							>
								Incluír
							</Button>
						</Popconfirm>
					}
					<Button
						type="primary"
						icon={<LeftOutlined />}
						size="large"
						onClick={() => {							
							onChargePrevious();
						}}
					/>
					<Button
						type="primary"
						icon={<RightOutlined />}
						size="large"
						onClick={() => {
							onChargeNext();							
						}}
					/>
				</Space>
			}
		>
			{
				currentInvoice.emission_process &&
				<Row gutter={[16, 16]} style={{marginBottom:"20px"}}>
					<Col span={currentInvoice.canceled? 8 : 6}></Col>
					{
						!currentInvoice.canceled && (user.role !== UserRols.INVOICES && user.role !== UserRols.CLIENT) && position === "in" &&
						<Col span={4}>
							<Button
								style={{width:"100%"}}
								type="primary"
								danger
								loading={loadingInvoices.includes(currentInvoice.id)}
								onClick={handleCancelInvoice}
							>
								Anular
							</Button>
						</Col>
					}
					<Col span={4}>
						<Button
							type="primary"
							style={{width:"100%"}}
							onClick={() => setOpenReviewInvoice(true)}
						>
							Descargar PDF
						</Button>
					</Col>
					<Col span={4}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={() => {handleOpenInvoice(currentInvoice);}}
						>
						Ver en SAT
						</Button>
					</Col>
				</Row>
			}
			{
				!currentInvoice.emission_process &&
				<Row gutter={[16, 16]} style={{marginBottom:"20px"}}>
					<Col span={8}>
					</Col>
					<Col span={4}>
						<Button
							type="primary"
							style={{width:"100%"}}
							onClick={() => setOpenReviewInvoice(true)}
						>
							Descargar PDF
						</Button>
					</Col>
					<Col span={4}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={() => {handleOpenInvoice(currentInvoice);}}
						>
							Ver en SAT
						</Button>
					</Col>
				</Row>
			}
			<Descriptions
				layout="horizontal"
				column={6}
				labelStyle={{
					//color: "black",
					fontWeight: "bold",
				}}
			>
				<Descriptions.Item label="Serie" span={1}>
					{currentInvoice.reference}
				</Descriptions.Item>
				<Descriptions.Item label="Número" span={1}>
					{currentInvoice.number}
				</Descriptions.Item>
				<Descriptions.Item label="Tipo" span={1}>
					{currentInvoice.type}
				</Descriptions.Item>
				<Descriptions.Item label="Moneda" span={1}>
					{currentInvoice.currency}
				</Descriptions.Item>
				<Descriptions.Item label="Fecha de Emisión" span={1}>
					{formatShownDate(currentInvoice.date)}
				</Descriptions.Item>
				{
					<Descriptions.Item label="Fecha Contable" span={1}>
						<DatePicker
							disabled={
								!AllowedInvoicesStatesForEdit.includes(lastSelectedState) ||
								UnallowedUserForEdit.includes(user.role)
							}
							value={
								currentInvoice.accounting_specifications[position].accounting_date ?
									dayjs(currentInvoice.accounting_specifications[position].accounting_date) :
									null
							}
							onChange={handleChangeAccountingDate}
						/>
					</Descriptions.Item>
				}
				{
					position === "in" &&
					<Descriptions.Item span={1}/>
				}
				<Descriptions.Item label="" span={1}/>
				<Descriptions.Item label={position == "in"? "Nit Receptor" : "Nit Emisor"} span={1}>
					{position == "in"? currentInvoice.receptor_id : currentInvoice.sender_id }
				</Descriptions.Item>
				<Descriptions.Item label={position == "in"? "Nombre Receptor" : "Nombre Emisor"} span={4}>
					{position == "in"?  currentInvoice.receptor_name  : currentInvoice.sender_name}
				</Descriptions.Item>
				<Descriptions.Item label="" span={1}/>
				<Descriptions.Item label="Establecimiento Emisor" span={4}>
					{currentInvoice.establishment_name}
				</Descriptions.Item>
				<Descriptions.Item label="" span={1}>
					{isr && <div>ISR APLICABLE</div>}
				</Descriptions.Item>
				<Descriptions.Item label="" span={1}/>
				<Descriptions.Item label={"Diario"} span={4}>
					<Select
						showSearch
						disabled={										
							!AllowedInvoicesStatesForEdit.includes(lastSelectedState) ||
							UnallowedUserForEdit.includes(user.role)
						}
						status={
							currentInvoice.accounting_specifications[position].diary ? "" : InvoiceStates.ERROR
						}
						placeholder="Selecciona un Diario"
						optionFilterProp="children"
						onChange={handleChangeDiary}
						value={findAccountNameById(
							company.accounting_resources.diaries,
							currentInvoice.accounting_specifications[position].diary
						)
						}
						filterOption={(input, option) =>
							(option?.label ?? "")
								.toLowerCase()
								.includes(input.toLowerCase())
						}
						style={{
							width: "100%",
						}}
						options={
							company.accounting_resources.diaries
								? company.accounting_resources.diaries									
									.filter((element) => position === "in" ? element.type === "sale" : element.type === "purchase" || element.type === "general")
									.map((element) => ({
										label: element.name,
										value: element.id,
									}))
								: []
						}
					/>
				</Descriptions.Item>
				<Descriptions.Item label="" span={1}></Descriptions.Item>
				<Descriptions.Item label="" span={1}></Descriptions.Item>
				<Descriptions.Item label={"Descripción General"} span={4}>
					<TextArea
						rows={3}
						showCount
						disabled={
							!AllowedInvoicesStatesForEdit.includes(lastSelectedState) ||
							UnallowedUserForEdit.includes(user.role)
						}
						status={
							currentInvoice.accounting_specifications[position].description
								? ""
								: InvoiceStates.ERROR
						}
						value={
							currentInvoice.accounting_specifications[position].description
								? currentInvoice.accounting_specifications[position].description
								: ""
						}
						style={{
							minWidth: "150px",
							marginBottom: "15px",
						}}
						placeholder="Ingresa una descripción"
						onChange={(event) => handleDescription(event.target.value)}
					/>
				</Descriptions.Item>
				<Descriptions.Item label="" span={1}></Descriptions.Item>
				<Descriptions.Item label="" span={1}></Descriptions.Item>
				<Descriptions.Item label="Gran Total" span={2}>
					<h1>
						{formatNumberOfCurrency(
							currentInvoice.total,
							currentInvoice.currency !== "" ? currentInvoice.currency : "GTQ"
						)}
					</h1>
				</Descriptions.Item>
				{currentInvoice.taxes !== null && currentInvoice.taxes.length !== 0 && (
					<Descriptions.Item label={"Impuestos"} span={2}>
						<Table
							size="small"
							pagination={false}
							bordered={false}
							style={{
								width: "100%",
							}}
							columns={[
								{
									title: "Impuesto",
									dataIndex: "name",
									key: "name",
								},
								{
									title: "Precio",
									dataIndex: "total",
									key: "total",
								},
							]}
							dataSource={
								currentInvoice.taxes.map((item, index) => ({
									key: index,
									name: item.name,
									total: formatNumberOfCurrency(
										item.total,
										currentInvoice.currency !== "" ? currentInvoice.currency : "GTQ"
									),
								}))}
						/>
					</Descriptions.Item>
				)}
				{(currentInvoice.taxes === null || currentInvoice.taxes.length === 0) && (
					<Descriptions.Item label={"Impuestos"} span={2}>
						<div>Este documento no tiene impuestos</div>
					</Descriptions.Item>
				)}
				<Descriptions.Item label="" span={1}></Descriptions.Item>
				<Descriptions.Item label="" span={1}></Descriptions.Item>

				<Descriptions.Item label="" span={2} style={{paddingRight: 40}}>
					{currentInvoice.tax_authority_specifications.frases !== null &&
						currentInvoice.tax_authority_specifications.frases.length !== 0 && (
						<Table
							size="small"
							style={{
								width: "100%",
							}}
							pagination={false}
							columns={[
								{
									title: "Especificaciones",
									dataIndex: "frase",
									key: "frase",
									render: (text) => <>{text}</>,
								},
							]}
							dataSource={currentInvoice.tax_authority_specifications.frases.map((frase) => {
								const typeKey = frase.type && frase.type !== "" ? frase.type : "defaultValueForType";
								const scenarioKey = frase.scenario && frase.scenario !== "" ? frase.scenario : "defaultValueForScenario";
								const fraseValue = frases[typeKey] && frases[typeKey][scenarioKey]
									? frases[typeKey][scenarioKey]
									: "";

								return { frase: fraseValue };
							})}
						/>
					)}
					{currentInvoice.tax_authority_specifications.frases === null &&
						currentInvoice.tax_authority_specifications.frases.length !== 0 && (
						<div>Este documento no tiene leyendas</div>
					)}
				</Descriptions.Item>
				<Descriptions.Item label="Tipo de Gasto General" span={2}>
					<Select
						showSearch
						disabled={
							!AllowedInvoicesStatesForEdit.includes(lastSelectedState) ||
							UnallowedUserForEdit.includes(user.role)
						}
						status={
							currentInvoice.accounting_specifications[position][getKindOfType[position]]
								? ""
								: InvoiceStates.ERROR
						}
						placeholder="Selecciona un Tipo de Gasto"
						optionFilterProp="children"
						onChange={handleChangeType}
						value={
							currentInvoice.accounting_specifications[position][getKindOfType[position]]
								? currentInvoice.accounting_specifications[position][getKindOfType[position]]
								: ""
						}
						filterOption={(input, option) =>
							(option?.label ?? "")
								.toLowerCase()
								.includes(input.toLowerCase())
						}
						style={{
							width: "100%",
						}}
						options={[
							{
								value: "compra",
								label: "Compra/Bien",
							},
							{
								value: "servicio",
								label: "Servicio",
							},
							{
								value: "combustible",
								label: "Combustible",
							},
						]}
					/>
				</Descriptions.Item>
				<Descriptions.Item label="" span={1}></Descriptions.Item>
				<Descriptions.Item label="" span={6}>
					<Divider>Items</Divider>
				</Descriptions.Item>
				{currentInvoice.items && (
					<Descriptions.Item label="" span={6}>
						<Table
							size="small"
							style={{
								width: "100%",
							}}
							pagination={false}
							bordered={false}
							columns={[
								{
									title: "Cantidad",
									dataIndex: "quantity",
									key: "quantity",
									render: (text) => (
										<div style={{ width: "60px" }}>{text}</div>
									),
								},
								{
									title: "Tipo",
									dataIndex: "type",
									key: "type",
									render: (text) => (
										<div style={{ width: "30px" }}>{text}</div>
									),
								},
								{
									title: "Descripción Inicial",
									dataIndex: "description",
									key: "description",
								},
								{
									title: "Clasificación",
									dataIndex: "accounting_classification",
									key: "accounting_classification",
									render: (value) => (
										<Select
											showSearch
											disabled={
												!AllowedInvoicesStatesForEdit.includes(lastSelectedState) ||
												UnallowedUserForEdit.includes(user.role)
											}
											placeholder="Clasificación"
											filterOption={(input, option) =>
												(option?.label ?? "")
													.toLowerCase()
													.includes(input.toLowerCase())
											}
											status={
												currentInvoice.items.find((item) => item.line === value[1])
													.accounting_specifications[position].accounting_classification
													? ""
													: InvoiceStates.ERROR
											}
											value={
												findAccountNameById(
													company.accounting_resources.accounting_plan,
													currentInvoice.items.find((item) => item.line === value[1])
														.accounting_specifications[position].accounting_classification
												)
											}
											style={{
												minWidth: "100px",
												width: "100%",
											}}
											popupMatchSelectWidth={false}
											options={
												company.accounting_resources.accounting_plan && company.accounting_resources[getKindOfAccounts[position]]
													? company.accounting_resources.accounting_plan
														.filter((element) =>
															// expense_accounts seria de compras
															company.accounting_resources[getKindOfAccounts[position]].includes(
																element.id
															)
														)
														.map((element) => ({
															label: element.display_name,
															value: element.id,
														}))
													: []
											}
											onChange={(element) =>
												selectItemClassification(element, value[1])
											}
										/>
									),
								},
								{
									title: "Analítica",
									dataIndex: "analytic_classification",
									key: "analytic_classification",
									render: (value) => (
										<Select
											showSearch
											disabled={
												!AllowedInvoicesStatesForEdit.includes(lastSelectedState) ||
												UnallowedUserForEdit.includes(user.role)
											}
											placeholder="Analíticas"
											filterOption={(input, option) =>
												(option?.label ?? "")
													.toLowerCase()
													.includes(input.toLowerCase())
											}
											status=""
											value={
												findAccountNameById(
													company.accounting_resources.others.analytic_accounts,
													currentInvoice.items.find((item) => item.line === value[1])
														.accounting_specifications[position].analytic_classification
												)
											}
											style={{
												minWidth: "100px",
												width: "100%",
											}}
											popupMatchSelectWidth={false}
											options={
												company.accounting_resources.others.analytic_accounts
													? company.accounting_resources.others.analytic_accounts
														.map((element) => ({
															label: element.name,
															value: element.id,
														}))
													: []
											}
											onChange={(element) =>
												selectItemAnalyticClassification(element, value[1])
											}
										/>
									),
								},
								{
									title: "Total",
									dataIndex: "total",
									key: "total",
									render: (text) => (
										<div style={{ width: "100px" }}>{text}</div>
									),
								},
								{
									title: "Impuestos",
									dataIndex: "taxes",
									key: "taxes",
									render: (taxes) => (
										<>
											{taxes.length === 0 && (
												<div>Este producto no tiene impuestos</div>
											)}
											{taxes.length !== 0 &&
												taxes.map((tax) => (
													<Tag color="blue" key={tax.name}>
														{tax.name +
															" = " +
															formatNumberOfCurrency(
																tax.total,
																currentInvoice.currency !== ""
																	? currentInvoice.currency
																	: "GTQ"
															)}
													</Tag>
												))}
										</>
									),
								},
							]}
							dataSource={currentInvoice.items.map((item, index) => ({
								key: index,
								quantity: item.quantity,
								type: item.type,
								description: item.initial_description,
								accounting_classification: [
									item.accounting_classification,
									item.line,
								],
								analytic_classification: [
									item.analytic_classification,
									item.line
								],
								total: formatNumberOfCurrency(
									item.total,
									currentInvoice.currency !== "" ? currentInvoice.currency : "GTQ"
								),
								taxes: item.taxes,
							}))}
						/>
					</Descriptions.Item>
				)}
				{lastSelectedState === InvoiceStates.UNVERIFIED && !isr && (user.role !== UserRols.BILLING && user.role !== UserRols.CLIENT) && (
					<Descriptions.Item label="" span={6}>
						<Button
							type="primary"
							size="large"
							style={{
								width: "100%",
								height: "80px",
								fontSize: "40px",
								fontWeight: "bold",
							}}
							loading={loadingInvoices.includes(currentInvoice.id)}
							onClick={handleSendInvoice}
						>
							Guardar
						</Button>
					</Descriptions.Item>
				)}
				{lastSelectedState === InvoiceStates.UNVERIFIED && isr && (user.role !== UserRols.BILLING && user.role !== UserRols.CLIENT) && (
					<>
						<Descriptions.Item label="" span={6}>
							<Button
								type="primary"
								size="large"
								style={{
									width: "100%",
									height: "80px",
									fontSize: "40px",
									fontWeight: "bold",
								}}
								loading={loadingInvoices.includes(currentInvoice.id)}
								onClick={openModal}
							>
								Guardar
							</Button>
							<Modal
								title="Aplica ISR"
								centered
								open={isModalOpenSend}
								onOk={handleOkSend}
								onCancel={closeModal}
								width={180}
							>
								<div
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "center",
									}}
								>
									<Switch
										checked={sendWithIsr} // changed from sendWithIsr to onChangeSwitchISR
										onChange={toggleIsr}
									/>
								</div>
							</Modal>
						</Descriptions.Item>
					</>
				)}
			</Descriptions>
			{open && 
				<PdfReportReview
					open={openReviewInvoice}
					content={currentInvoice}
					renderContent={(invoice) => <InvoiceNormalTemplate invoice={invoice} />}
					onSetOpen={setOpenReviewInvoice}
					onConfirmAction={()=>generate_invoice_pdf(currentInvoice, (invoice) => <InvoiceNormalTemplate invoice={invoice} />)}
					title={"Prevista de la Factura de venta antes de descargar"}
					confirmText={"Descargar"}
				/>
			}
		</Drawer>
	);
};

Invoice.propTypes = {
	// ESCENTIAL PROPERTIES
	token: PropTypes.string.isRequired,
	currentInvoice: PropTypes.object.isRequired,
	lastSelectedState: PropTypes.string.isRequired,
	user: PropTypes.shape({
		email: PropTypes.string.isRequired,
		role: PropTypes.string.isRequired,
	}),
	company: PropTypes.shape({
		id: PropTypes.string.isRequired,
		tid: PropTypes.string.isRequired,
		database: PropTypes.object,
		accounting_resources: PropTypes.shape({
			diaries: PropTypes.array,
			accounting_plan: PropTypes.array,
			others: PropTypes.shape({
				analytic_accounts: PropTypes.array
			}),
			expense_accounts: PropTypes.array,
			sale_accounts: PropTypes.array,
		})
	}),
	position: PropTypes.string.isRequired,
	// Filters Allowed
	AllowedInvoicesStatesForEdit: PropTypes.array.isRequired,
	UnallowedUserForEdit: PropTypes.array,
	// EMITION FUNCTIONS
	onUpdateItem: PropTypes.func,
	onEmitClose: PropTypes.func,
	onChargePrevious: PropTypes.func,
	onChargeNext: PropTypes.func,
	onSubmitInvoiceChanges: PropTypes.func,
	onResetInvoices: PropTypes.func,
};

